import React from 'react'
import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import { ColorBoxContent } from '../ui/colorBox'

function StatCell({ data }) {
  return (
    <ColorBoxContent
      style={{
        display: 'flex',
        alignItems: 'center',
        height: '100px'
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography>{data.title}</Typography>
        <Typography variant='h3' style={{ margin: '0px 4px' }}>
          {data.info}
        </Typography>
      </Box>
    </ColorBoxContent>
  )
}

StatCell.propTypes = {
  data: PropTypes.object
}

export default StatCell
